import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const ServerIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M13 11.3653C13.5523 11.3653 14 11.813 14 12.3653V14.3653C14 14.9176 13.5523 15.3653 13 15.3653H3C2.44772 15.3653 2 14.9176 2 14.3653V12.3653C2 11.813 2.44772 11.3653 3 11.3653H13ZM4 12.6153C3.58579 12.6153 3.25 12.9511 3.25 13.3653C3.25 13.7795 3.58579 14.1153 4 14.1153C4.41421 14.1153 4.75 13.7795 4.75 13.3653C4.75 12.9511 4.41421 12.6153 4 12.6153ZM13 6.36526C13.5523 6.36526 14 6.81298 14 7.36526V9.36526C14 9.91755 13.5523 10.3653 13 10.3653H3C2.44772 10.3653 2 9.91755 2 9.36526V7.36526C2 6.81298 2.44772 6.36526 3 6.36526H13ZM4 7.61526C3.58579 7.61526 3.25 7.95105 3.25 8.36526C3.25 8.77947 3.58579 9.11526 4 9.11526C4.41421 9.11526 4.75 8.77947 4.75 8.36526C4.75 7.95105 4.41421 7.61526 4 7.61526ZM13 1.36526C13.5523 1.36526 14 1.81298 14 2.36526V4.36526C14 4.91754 13.5523 5.36526 13 5.36526H3C2.44772 5.36526 2 4.91754 2 4.36526V2.36526C2 1.81298 2.44772 1.36526 3 1.36526H13ZM4 2.61526C3.58579 2.61526 3.25 2.95105 3.25 3.36526C3.25 3.77947 3.58579 4.11526 4 4.11526C4.41421 4.11526 4.75 3.77947 4.75 3.36526C4.75 2.95105 4.41421 2.61526 4 2.61526Z"
		/>
	</svg>
))
